import { render, staticRenderFns } from "./StatusControlActors.vue?vue&type=template&id=4e0815c8&scoped=true&"
import script from "./StatusControlActors.vue?vue&type=script&lang=js&"
export * from "./StatusControlActors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0815c8",
  null
  
)

export default component.exports